export default "__VITE_ASSET__df61c542__"